import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=590a003c"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=590a003c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590a003c')) {
      api.createRecord('590a003c', component.options)
    } else {
      api.reload('590a003c', component.options)
    }
    module.hot.accept("./SvgIcon.vue?vue&type=template&id=590a003c", function () {
      api.rerender('590a003c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SvgIcon.vue"
export default component.exports